<template>
	<b-row>
		<b-col>
			<b-row>
				<b-col cols="12">
					<label :class="`mh-label${rejecting ? ' required' : ''}`">Comments</label>
					<b-textarea v-model="comments" />
				</b-col>
			</b-row>
			<b-row>
				<b-col cols="6">
					<button class="btn btn-default btn-grey btn-block" @click="closeForm()">Cancel</button>
				</b-col>
				<b-col cols="6">
					<button :class="`btn btn-default btn-block${approving ? ' btn-green' : ''}`" @click="saveForm()">{{approving ? "Approve" : "Reject"}}</button>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
	export default {
		name: 'SetInvoiceStatusForm',
		props: {
			data: null,
			approving: false,
			rejecting: false
		},
		data: function () {
			return {
				comments: null
			}
		},
		computed: {
			isCommentsValid: function () {
				if (this.rejecting && (this.comments == null || this.comments == "")) {
					this.$store.commit("Toasts/showError", { title: "Comments", content: "Comments are required" })

					return false
				}

				return true
			}
		},
		methods: {
			closeForm: function () {
				this.$emit("close-form")
			},
			isFormValid: function () {
				return this.isCommentsValid
			},
			saveForm: function () {
				if (!this.isFormValid())
					return

				var $this = this

				this.$store.commit("Confirmation/show", {
					text: `Are you sure you want to ${this.approving ? "approve" : "reject"} invoice <b>${this.data.invoicenumber}</b>?`,
					okCallback: function () {
						var parameters = {
							id: $this.data.id,
							status: $this.approving ? 4 : 5,
							comment: $this.comments
						}

						$this.$store.dispatch("Invoices/setInvoiceStatus", parameters).then(function () {
							$this.$emit("save-form")
						})
					},
					cancelCallback: null
				})
			}
		}
	}
</script>

<style scoped>
</style>